import { useState } from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { CreditCard, PaymentForm } from "react-square-web-payments-sdk";

const base_url = "https://us-central1-manageyourclub-973b2.cloudfunctions.net";
const location_id = "LX7G9VDFPSK3F";
const application_id = "sq0idp-6wZODOhmXwv1b8gqXTtmGQ";

export const requiresAuth = (cartItems) => {
  return cartItems.some(
    (item) =>
      item.type === "pass" ||
      item.type === "ticket" ||
      item.productType === "pass" ||
      item.productType === "ticket"
  );
};

export const PaymentProcessor = ({
  total,
  cartItems,
  member,
  clubId,
  discount,
  shippingGroups,
  onPaymentSuccess,
  onPaymentError,
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const createPaymentRequest = () => {
    if (total <= 0) return null;

    return {
      countryCode: "US",
      currencyCode: "USD",
      total: {
        amount: (total / 100).toString(),
        label: "Total",
      },
      lineItems: cartItems,
      requestBillingContact: true,
      requestShippingContact: false,
    };
  };

  const handlePayment = async (token) => {
    setIsProcessing(true);
    try {
      const response = await fetch(`${base_url}/checkout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          memberId: member.id,
          clubId,
          lineItems: cartItems,
          discount,
          total,
          currency: "USD",
          sourceId: token,
          shippingGroups: shippingGroups,
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
      }

      const order = await response.json();
      onPaymentSuccess(order);
    } catch (error) {
      onPaymentError(error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <PaymentForm
      applicationId={application_id}
      cardTokenizeResponseReceived={handlePayment}
      createPaymentRequest={createPaymentRequest}
      locationId={location_id}
    >
      <Container sx={{ my: 4 }}>
        {total <= 0 ? (
          <>
            <Typography variant="h5" color="error" gutterBottom>
              Your total is $0.00. No payment is required.
            </Typography>
            <Button
              onClick={() => handlePayment({ token: "FREE" })}
              variant="contained"
              color="primary"
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Complete Order"}
            </Button>
          </>
        ) : (
          <CreditCard
            buttonProps={{
              isLoading: isProcessing,
              css: {
                backgroundColor: "#2c7e3f",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#569765",
                },
              },
            }}
          />
        )}
        <Box sx={{ my: 2 }} />
      </Container>
    </PaymentForm>
  );
};
